

import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { provideRouter, withHashLocation } from '@angular/router';
import { errorInterceptor } from '@services/security/error.interceptor';
import { httpInterceptor } from '@services/security/http.interceptor';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withHashLocation()),

    importProvidersFrom(
      BrowserAnimationsModule
    ),

    provideHttpClient(withInterceptors([
      httpInterceptor,
      errorInterceptor
    ]))

  ]
};
